<template>
  <div class="cx_sidebar_group">
    <SideBarItem @selected="selected" :title="title" :to="to" :perm="perm" :icon="icon" :svg="svg" :indent="indent" :iconColor="iconColor" :tooltip="tooltip">
      <!-- 矢印アイコンでの開閉を停止 -->
      <!-- <template slot="icon">
        <i class="material-icons small valign" @click="collapse" v-if="items.length !=0">{{arrowIcon}}</i>
      </template> -->
      <span class="badge" :class="{'ok': count == 0}" v-if="count || count == 0">{{count}}</span>
    </SideBarItem>
    <b-collapse :id="title" v-model="opened">
      <slot :parent="_self"></slot>
      <!-- 直接追加 -->
      <div v-for="(item,index) in items" :key="index">
        <div class="cx_drop_target"  :class="{active:index==targetId}"></div>
        <SideBarItem class="item"  :to="getPath(index)" :indent="4" :iconColor="item.iconColor" :parent="_self" :title="item.name" :count ="item.count"
        @dragstart="dragStart(index, $event)" @dragover="dragOver(index, $event)" @drop="drop(index, $event)" @dragleave="dragleave" :isFavoriteEditable="isEditable(item)"/>
      </div>
      <div class="cx_drop_target"  :class="{active:items.length==targetId}"></div>
    </b-collapse>
    <!-- お気に入り編集画面 -->
    <!-- <b-modal class="cx_listView_favorite" v-model="showFavorite" title="名称の変更" @ok="execFavorite" :no-close-on-backdrop="true" centered>
      <TextBox title="表示名称" :isEdit="true" :value.sync="favorite.name" :required="true" placeholder="Enter Name" ref="favoriteName" v-if="showFavorite" />
      <RadioButton title="表示区分" :enabled="false" :value="favorite.isTenant" list="favoriteFlags" v-if="showFavorite"/>      
    </b-modal>             -->
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class SideBarGroup extends Vue {
  @Prop() public title!: string;
  @Prop() public accordion!: string;

  //sidebar.vueから直接お気に入りメニューを追加するためのプロパティ
  @Prop() public to!: string;
  @Prop({ default: null }) public perm: string;
  @Prop({ default: null }) public icon: string;
  @Prop({ default: null }) public svg: string;  
  @Prop({ default: 0 }) public indent: number;
  @Prop({ default: '#495057' }) public iconColor: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:null}) public count: number;
  @Prop() public query: string;  //クエリ

  public items: Common.Favorite[] = new Array(0);
  
  public opened: boolean = false;
  public arrowIcon: string = 'arrow_right';

  public mounted(){
    if (this.$route.fullPath == this.to){
      this.$nextTick(()=>this.selected());
    }
  }
  public apend(item: Components.SideBarItem){
    //グループ内にターゲットがある場合はオープンすうｒ。
    if (this.$route.fullPath == item.to){
      // this.$nextTick(()=>this.collapse());
      this.$emit('selected', this);
    }
  }
  public isEditable(item: Common.Favorite){
    return item.isTenant == false || this.$api.perms.hasMenuPermission(Common.Favorite.perm);
  }
  @Watch('opened')
  public onValueChange(newValue: boolean, oldValue: boolean): void {
    if (this.opened) {
      this.arrowIcon = 'arrow_drop_down';
    } else {
      this.arrowIcon = 'arrow_right';
      //クエリパラメータを除外して一致している場合は、リダイレクトする
      if (this.to != this.$route.fullPath && this.to == this.$route.path) {
        this.$router.push(this.to);
      }
    }
  }
  
  public getPath(index: number) {
    const item = this.items[index];
    return item.path + '?favorite=' + item.key + '&static=1';
  }

  public selected() {
      this.$emit('selected', this);
  }

  public collapse() {
    this.opened = !this.opened;
    if (this.opened) {
      this.arrowIcon = 'arrow_drop_down';
    } else {
      this.arrowIcon = 'arrow_right';
    }
  }

  // public favorite : Common.Favorite;
  // public showFavorite:boolean = false;
  // public onEditFavorite(to:string) {
  //   this.favorite = this.items.find(item =>item.path + '?favorite=' + item.key + '&static=1' == to );
  //   this.favorite = this.favorite.binder.loadInstance(this.favorite); //クローン
  //   this.showFavorite = true;
  // }
  // public execFavorite(){
  //   //更新する
  //   this.$api.update(this.favorite);
  //   var index = this.items.findIndex(item => item.id == this.favorite.id);
  //   this.items[index] = this.favorite;    
  // }

  public onDelete(to : string){
    var target = this.items.find(item =>item.path + '?favorite=' + item.key + '&static=1' == to );
    this.$api.modal.showDialog('確認',String.format('お気に入り「{0}」を削除してよろしいですか?',target.name),false).then(()=>{
            
      this.$api.remove(target).then(()=>this.reload()).then(()=>this.$router.push(this.to));      
    });
  }



  private sourceId:number;
  private targetId:number = -1;
  public dragStart(index: number, e: any) {
    e.dataTransfer.effectAllowed = "move";
    this.sourceId = index;
    this.targetId = -1;
  }
  public dragOver(index: number, e: any) {
    if (e.preventDefault) e.preventDefault(); // Necessary. Allows us to drop.
    e.dataTransfer.dropEffect = 'move'; // See the section on the DataTransfer object.

    //スタートセルとの相対関係でドロップ境界を判定する
    const source = this.items[this.sourceId];
    const target = this.items[index];

    if (index == this.sourceId || source.isTenant != target.isTenant) this.targetId = -1;
    else if (index > this.sourceId) this.targetId = index + 1;
    else this.targetId = index;
    return false;
  }
  public drop(index: number, e: any) {     

    const source = this.items[this.sourceId];
    const target = this.items[index];
    this.targetId = -1;

    if(source.isTenant == target.isTenant && source.displayOrder != target.displayOrder && target.displayOrder >0)  {
      this.$api.execute(new Common.RowSequenceUpdateQuery(source,target.displayOrder)).then(()=>{
        this.reload();
      });
    }
  }    

  public dragleave(){
    this.targetId = -1;
  }

  public  async reload(){
    this.$api.execute(new Common.FavoriteQuery(Common.favoriteFlags.All,this.to))
    .then(res =>{
      //カウントをコピーする
      this.items.forEach(item => {
        var reloaded = (res.result as Array<Common.Favorite>).find(obj =>obj.id == item.id);
        if (reloaded) reloaded.count = item.count;
      });
      this.items = res.result;
      this.$forceUpdate();
      return Promise.resolve();
      });
  }
}
</script>
<style lang="scss">
.cx_sidebar_group{
  .badge{
    margin-left: 10px;
    font-size:11px;
    background-color: red;
    color:white;
    border-radius: 10rem;

    &.ok {
      background-color: rgb(149, 190, 126);      
    }
  }

  .collapsing{
    -webkit-transition: height 0.20s ease;
    transition: height 0.20s ease;    
  }
  .cx_drop_target{
    height: 1px;    
    margin-left: 20px;
    margin-right: 30px;
    &.active{
      background-color: lightgrey;
    }
  }
}

</style>